import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { debounce } from 'lodash-es';
import { getString } from '@/modules/common/helpers/resources';
import {
  checkResetToken,
  commitResetToken,
  getThemeByParam,
  unblockHash
} from '@/modules/common/services/http/account';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { verifyPassword } from '@/modules/authentication/helpers';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { notify } from '@/modules/common/helpers/notification';
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading,
  InputPassword,
  LoaderIndicator,
  Modal,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isLoading = ref(true);
const comittingSetup = ref(false);
const setupToken = ref(route.params.token as string);
const password = ref('');
const passwordConfirm = ref('');
const passwordScore = ref(0);
const isPasswordValid = ref(false);
const passwordMessage = ref('');
const unblockModalOpen = ref(false);
const progressColor = ref(NebraskaColors.statusInfo);

const enableButton = computed(
  () => isPasswordValid.value && password.value === passwordConfirm.value
);

const passwordStrengthColor = computed(() => {
  return passwordScore.value <= 0.1
    ? NebraskaColors.statusNegative
    : progressColor.value;
});

const debounceVerifyPassword = debounce(async () => {
  const response = await verifyPassword(password.value);
  if (response) {
    passwordScore.value = response.passwordScore;
    passwordMessage.value = response.passwordMessage;
    isPasswordValid.value = response.isPasswordValid;
    progressColor.value = response.progressColor;
  }
}, 300);

const onInputChange = () => {
  isPasswordValid.value = false;
  debounceVerifyPassword();
};

onMounted(async () => {
  try {
    await checkResetToken({ hash: setupToken.value });
    isLoading.value = false;
  } catch (error) {
    if (error instanceof Error && error.message === 'error_account_blocked') {
      unblockModalOpen.value = true;
    } else {
      notify({
        group: 'wrn-notifications',
        text: 'OPS! ESTA CHAVE DE ACESSO TEMPORÁRIA É INVÁLIDA',
        type: NotificationTypes.error
      });
      setTimeout(() => {
        router.push({ name: 'v3' });
      }, 2000);
    }
  }
});

const commitSetup = async () => {
  comittingSetup.value = true;
  try {
    const response = await commitResetToken({
      hash: setupToken.value,
      password: password.value
    });
    notify({
      group: 'wrn-notifications',
      text: 'Senha alterada com sucesso.',
      type: NotificationTypes.success
    });

    const theme = await getThemeByParam('email', response.user.email);
    const { domain, platform } = getDomainAndPlatform(theme);

    window.location.href = `/onboarding/${domain}/${platform}/login`;
  } catch {
    comittingSetup.value = false;
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possivel registrar a nova senha.',
      type: NotificationTypes.error
    });
  }
};
const unblockAccount = async () => {
  try {
    await unblockHash({ hash: setupToken.value, type: 'reset-password' });
    notify({
      group: 'wrn-notifications',
      text: getString('dialog_unblock_success'),
      type: NotificationTypes.success
    });
  } catch {
    comittingSetup.value = false;
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possivel desbloquear.',
      type: NotificationTypes.error
    });
  }
};
const closeUnblockModal = () => {
  router.push({ name: 'v3' });
};

return { __sfc: true,route, router, isLoading, comittingSetup, setupToken, password, passwordConfirm, passwordScore, isPasswordValid, passwordMessage, unblockModalOpen, progressColor, enableButton, passwordStrengthColor, debounceVerifyPassword, onInputChange, commitSetup, unblockAccount, closeUnblockModal, getString, NebraskaColors, BaseText, ButtonContainer, ButtonPrimary, Heading, InputPassword, LoaderIndicator, Modal, NavBar }
}

})